export const queryStringToObject = () => {
  const params = new URLSearchParams(location.search);

  return params
    .toString()
    .split('&')
    .reduce(
      (arr, value) => ({
        ...arr,
        [value.split('=')[0]]: decodeURIComponent(value.split('=')[1]),
      }),
      {}
    );
};

export const cleanQueryString = () => {
  const params = new URLSearchParams(location.search);
  const filterObj = params.toString().split('&');

  filterObj.forEach((data) => {
    params.delete(data.split('=')[0]);
  });

  window.history.replaceState({}, '', `${location.pathname}`);
};

export const setQueryString = (
  filterObj: Record<string, string | number | boolean | null | string[]>
) => {
  const params = new URLSearchParams(location.search);
  const initialValuesParams = [
    'orderBy',
    'pageSize',
    'sort',
    'limit',
    'offset',
  ];

  for (const data in filterObj) {
    // eslint-disable-next-line no-prototype-builtins
    if (filterObj.hasOwnProperty(data) && !initialValuesParams.includes(data)) {
      if (params.has(data) && !filterObj[`${data}`]) {
        params.delete(data);
      } else if (params.has(data)) {
        params.set(data, decodeURIComponent(`${filterObj[`${data}`]}`));
      } else {
        params.append(data, decodeURIComponent(`${filterObj[`${data}`]}`));
      }
    }
  }

  if (params.toString()) {
    window.history.replaceState({}, '', `${location.pathname}?${params}`);
  } else {
    window.history.replaceState({}, '', `${location.pathname}`);
  }
};
